// Per-operation config for the shared job-results page (JobResults). The results data model is
// identical across masking / encrypt / decrypt (the platform returns the same JobResultsResponseDTO
// and OrchestrationJobResponseDTO for all three) — only labels, icons, the API endpoints, and the
// back-link differ. Keeping these in one map is what lets a single component serve all three.
import { FaMask, FaLock, FaUnlock } from 'react-icons/fa';
import {
  getMaskingJob,
  getMaskingJobResults,
  getEncryptJob,
  getEncryptJobResults,
  getDecryptJob,
  getDecryptJobResults,
} from 'Secure/api';

export const JOB_RESULT_VARIANTS = {
  masking: {
    title: 'MASKING RESULTS',
    icon: FaMask,
    // verb past-tense for the per-unit row ("X rows masked"), and the summary card label.
    verb: 'masked',
    summaryLabel: 'Masked',
    headerTooltip: 'What was masked for this job, how long it took, and whether anything failed.',
    fallbackName: (jobId) => `Masking Job #${jobId}`,
    // Back link target: masking has a per-source summary page; encrypt/decrypt go to the encrypt list.
    backLink: (dataSourceId) =>
      dataSourceId != null
        ? { to: `/secure/masksummary/${encodeURIComponent(dataSourceId)}`, label: 'Masking Summary' }
        : null,
    getJob: getMaskingJob,
    getResults: getMaskingJobResults,
  },
  encrypt: {
    title: 'ENCRYPTION RESULTS',
    icon: FaLock,
    verb: 'encrypted',
    summaryLabel: 'Encrypted',
    headerTooltip: 'What was encrypted for this job, how long it took, and whether anything failed.',
    fallbackName: (jobId) => `Encryption Job #${jobId}`,
    backLink: () => ({ to: '/secure/encrypt', label: 'Encryption' }),
    getJob: getEncryptJob,
    getResults: getEncryptJobResults,
  },
  decrypt: {
    title: 'DECRYPTION RESULTS',
    icon: FaUnlock,
    verb: 'decrypted',
    summaryLabel: 'Decrypted',
    headerTooltip: 'What was decrypted for this job, how long it took, and whether anything failed.',
    fallbackName: (jobId) => `Decryption Job #${jobId}`,
    backLink: () => ({ to: '/secure/encrypt', label: 'Encryption' }),
    getJob: getDecryptJob,
    getResults: getDecryptJobResults,
  },
};
